function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils";
export var RoundIconButton = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, props = _objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("button", _extends({
        type: "button",
        className: twMerge(cx("flex flex-col items-center justify-center rounded-full", "w-[2rem] h-[2rem]", "transition-all text-fg-default hover:text-fg-inbetween", "[&>svg]:ml-1 [&>svg]:w-4 disabled:opacity-40", className))
    }, props), children);
};

//# sourceMappingURL=RoundIconButton.js.map